export const LOCALES: { ENGLISH: 'en'; CHINESE: 'cn'; RUSSIA: 'ru' } = {
	ENGLISH: 'en',
	CHINESE: 'cn',
	RUSSIA: 'ru'
}
